AgrimarketServices.service('categoryOfferService', ['$rootScope', '$http', '$location', 'currentUserFactory', 'configurationFactory',
    function ($rootScope, $http, $location, currentUserFactory, configurationFactory) {

        var SendRequest = function (configfile, callback) {
            $http(configfile)
                .success(function (data) {
                    callback(data, null, null, null);
                })
                .error(function (data, status, headers, config) {
                    callback(data, status, headers, config);
                });
        };

        this.GetAllCategoryOffers = function (callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'categoryOffer/GetAllCategoryOffers'
            };
            SendRequest(config, callback);
        };

        this.GetCategoryOfferPaginateWithFilter = function (searchText, max, pageNo, sortKey, reverse, callback) {
            var config = {
                method: 'GET',
                url: configurationFactory.Url['Api'] + 'categoryOffer/GetCategoryOfferPaginateWithFilter',
                params: {
                    searchText: searchText,
                    itemPerPage: max,
                    pageNo: pageNo,
                    sortKey: sortKey,
                    reverse: reverse
                }
            };
            SendRequest(config, callback);
        };

        this.PostCategoryOffer = function (data, callback) {
            var config = {
                method: 'POST',
                url: configurationFactory.Url['Api'] + 'categoryOffer/PostCategoryOffer',
                data: data
            };
            SendRequest(config, callback);
        };

        this.DeleteCategoryOffer = function (idCategoryOffer, callback) {
            var config = {
                method: 'DELETE',
                url: configurationFactory.Url['Api'] + 'categoryOffer/DeleteCategoryOffer',
                params: { idCategoryOffer: idCategoryOffer }
            };
            SendRequest(config, callback);
        };
    }]);